// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"090e5b3d","667":"4c7d4ec0","977":"3a2c26f3"}[chunkId] + ".chunk.js";
};